export default __webpack_public_path__ + "images/d010f892843c4c62e08b09d1138347c0.svg";